import { render } from "./Welcome.vue?vue&type=template&id=1cb9e194"
import script from "./Welcome.vue?vue&type=script&lang=js"
export * from "./Welcome.vue?vue&type=script&lang=js"
script.render = render

export default script